"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameEvent = void 0;
var GameEvent;
(function (GameEvent) {
    GameEvent["InitCritical"] = "init:critical";
    GameEvent["InitImportant"] = "init:important";
    GameEvent["InitModerate"] = "init:moderate";
    GameEvent["InitNormal"] = "init:normal";
    GameEvent["InitChill"] = "init:chill";
    GameEvent["GameStarted"] = "game:started";
})(GameEvent || (exports.GameEvent = GameEvent = {}));
